module.exports = __webpack_public_path__ + "static/media/the-green-milk-made-from-cells.4f5907da.jpg";